var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 24.818
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 14.909S6.455 4 16 4s15 10.909 15 10.909-5.455 10.909-15 10.909S1 14.909 1 14.909"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(11 9.909)"
  }))));
};
export default SvgEye;